module.exports = __webpack_public_path__ + "assets/media/announcer_ment_3.f5a3263c.mp3";